import { Injectable } from '@angular/core';

const MIN_LENGTH = 8;
const MAX_STRENGTH = 5;

@Injectable()
export class PasswordsService {

  // noinspection JSMethodCanBeStatic
  getMinLength(): number {
    return MIN_LENGTH;
  }

  // noinspection JSMethodCanBeStatic
  getMaxStrength(): number {
    return MAX_STRENGTH;
  }

  measureStrength(password: string): number {
    let s = 0;
    if (!password) {
      return 0;
    }
    if (password.length >= MIN_LENGTH) {
      s++;
    }
    [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].forEach(regex => {
      if (password.search(regex) !== -1) {
        s++;
      }
    });
    return s;
  }

  isValid(password: string): boolean {
    return this.measureStrength(password) >= MAX_STRENGTH;
  }
}
